module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/gems/gem-wood-180.png"+" 180w",
        images: [{path: __webpack_public_path__ + "assets/images/gems/gem-wood-180.png",width: 180,height: 180}],
        src: __webpack_public_path__ + "assets/images/gems/gem-wood-180.png",
        toString: function(){return __webpack_public_path__ + "assets/images/gems/gem-wood-180.png"},
        
        width: 180,
        height: 180
      }